import React from 'react';
import OrderUI from "../../components/admin/purchase_order/components/Order";
import PersistentDrawerLeft from "../../components/reusable/admin/Main";
const PurchaseOrder = () => {
  return (
    <div>
    <PersistentDrawerLeft>
      <OrderUI/>
    </PersistentDrawerLeft>
    </div>
  );
};

export default PurchaseOrder;